<mat-vertical-stepper labelPosition="bottom" [linear]="!isLinear" #stepper>
  <ng-template matStepperIcon="done">
    <mat-icon>done_all</mat-icon></ng-template
  >
  <ng-template matStepperIcon="number" let-index="index">
    {{ index + 1 }}
  </ng-template>
  <mat-step
    label="Import a MIDI file"
    [stepControl]="firstFormGroup"
    editable="true"
  >
    <form [formGroup]="firstFormGroup">
      <mat-file-upload [step]="'1'"></mat-file-upload>
      <br />
      <div>
        <button
          mat-stroked-button
          style="display: none"
          matStepperNext
          id="next1"
        >
          Next
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step
    label="Import an audio Vocal file"
    [stepControl]="secondFormGroup"
    editable="true"
  >
    <form [formGroup]="secondFormGroup">
      <div>
        <mat-file-upload
          (fileUrl)="getVocalUrl($event)"
          (midiDataJSON)="getMidiData($event)"
          [step]="'2'"
        ></mat-file-upload>
        <br />
        <div>
          <button mat-stroked-button matStepperPrevious>Back</button>
          <button
            mat-stroked-button
            style="display: none"
            matStepperNext
            id="next2"
            (click)="comp.compare(this.vocalUrl, this.midiData)"
          >
            Next
          </button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step state="done" label="Result" editable="false">
    <mat-comparison></mat-comparison>
    <div>
      <button mat-stroked-button matStepperPrevious>Back</button>
      <button mat-stroked-button onclick="location.reload();">Reset</button>
    </div>
  </mat-step>
</mat-vertical-stepper>
